import { gql } from '@apollo/client';


export const GET_GENERAL_WIDGETS = gql`
    query GeneralWidgets {
        generalWidgets{
            system_info{
                label
                info
            }
            site_api{
                label
                info
            }
        }
    }
`;